var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M12 5c3.864 0 7 3.136 7 7s-3.136 7-7 7-7-3.136-7-7 3.136-7 7-7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.375 15.025a.5.5 0 0 1-.374.15.5.5 0 0 1-.375-.15.5.5 0 0 1-.15-.374v-2.975q0-.224.15-.374.15-.151.374-.151c.224 0 .274.05.374.15a.5.5 0 0 1 .151.375v2.975q0 .222-.15.374m.028-5.235a.55.55 0 0 1-.403.163.55.55 0 0 1-.402-.163.55.55 0 0 1-.163-.403.55.55 0 0 1 .162-.403.55.55 0 0 1 .403-.162q.24 0 .403.162a.55.55 0 0 1 .163.403q0 .24-.163.403"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-gray.4f1cd077.svg";